// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2vQSK","list":"PatternAutocomplete_list__7s_lC"};